import React, {useRef, useEffect} from 'react';

import Plus from '../icons-af/plus';
import Check from '../icons-af/check';

import useModal from '../../hooks/use-modal/use-modal';
import {on, off} from '../../utils/events';
import constantsFactory from '../../utils/constants';
import useTranslation from '../../hooks/use-translation/use-translation';
import {H2, H4, H5, P} from '../typography/typography';
import './modal-instalments-deko.scss';

const {EVENTS} = constantsFactory();

const ModalInstalmentsDeko = () => {
  const target = useRef(null);
  const modal = useModal(target);
  const {t} = useTranslation();

  useEffect(() => {
    on(EVENTS.CLICK_PAY_IN_INSTALMENTS, modal.open);

    return () => {
      off(EVENTS.CLICK_PAY_IN_INSTALMENTS, modal.open);
      modal.destroy();
    };
  }, [modal]);

  return (
    <div
      ref={target}
      className="modal fade modal-instalments-deko"
      tabIndex={-1}
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <span>
              <img
                loading="lazy"
                src="https://d2m7ibezl7l5lt.cloudfront.net/img/v2/logo/artfinder-red.e718a82ca19a.png"
                alt="Artfinder"
                width="115"
              />
              <Plus width="30px" height="20px" />
              <img
                loading="lazy"
                src="https://d2m7ibezl7l5lt.cloudfront.net/img/checkout/Deko_colour_trans_200.9d910571bb38.png"
                alt="Deko – spread the cost over 10 months with 0%"
                width="115"
              />
            </span>
            <H2 style="title">{t('Buy art now. Pay later')}.</H2>
            <H4 style="p1-b">{t('Make interest free payments over 6 or 10 months')}.</H4>
            <P style="p2">
              {t(
                'Pay a 10% deposit now, receive your artwork, then spread the remaining cost over your chosen time frame',
              )}
              .
            </P>
            <div className="row">
              <div className="col-6">
                <Check width="26px" height="26px" />
                <H5 style="p1-b">{t('Quick and easy')}</H5>
                <P style="p2">{t('Apply and get a decision instantly')}.</P>
              </div>
              <div className="col-6">
                <Check width="26px" height="26px" />
                <H5 style="p1-b">{t('No hidden fees')}</H5>
                <P style="p2">{t('No hidden costs or surprises!')}</P>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <P style="p2">
              {t(
                'Subject to credit check and approval. 10% deposit payment required. 0% APR representative. Only applicable on orders over £300',
              )}
              .{' '}
              <a href="/help/installments-uk/" target="_blank">
                {t('Please read full terms here')}.
              </a>
            </P>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalInstalmentsDeko;
